
    //Здесь будет код, который будет относиться только к странице index

$(document).ready(function () {

     setMediaImagesSize();

    window.addEventListener('resize',  setMediaImagesSize);

    function  setMediaImagesSize() {
        if (document.documentElement.clientWidth <= 768) {
            setMediaImgSize('mob');
        } else if (document.documentElement.clientWidth > 768 && document.documentElement.clientWidth < 1200) {
            setMediaImgSize('tablet');
        } else {
            setMediaImgSize('desktop');
        }
    }
    function setMediaImgSize(type) {
        $('img').each(function () {
            if ($(this).data(type)) {
                $(this).attr('src', $(this).data(type));
            } else {
                $(this).attr('src', $(this).data('desktop'));
            }
        });
    }

});

    /**
    *   Подписка на рассылку новостей
    */
    eventClick('.main-subscription__submit', function (){

        request('POST', `${window.current_region}/news-subscription`, {email: $('.main-subscription__input').val()}, function (response) {
            showSuccess(response);
            $('.main-subscription').hide();
            $('.guest-promo').show();
        })
    })
